module.exports = __webpack_public_path__ + "static/media/car-1.f4bdec83.jpg";